export const lv = {
    seo: {
        title: 'MyCarCosts | Auto izmaksu uzskaite, apkopes žurnāls un analīze',
        description: 'Digitālais auto apkopes žurnāls. Seko līdzi izmaksām, degvielai un vēsturei. AI remonta analīze — uzzini, vai remontēt vai pārdot savu auto.'
    },
    common: {
        back: "Atpakaļ",
        save: "Saglabāt",
        saved: "Saglabāts",
        cancel: "Atcelt",
        close: "Aizvērt",
        accessDenied: "Piekļuve liegta",
        noExportPermission: "Jums nav tiesību eksportēt šī auto datus.",
        delete: "Dzēst",
        downgrade: "Pāriet uz zemāku plānu",
        downgradeConfirm: "Vai tiešām vēlaties pāriet uz Bezmaksas plānu?",
        edit: "Rediģēt",
        loading: "Ielādē...",
        confirm: "Apstiprināt",
        processing: "Apstrādā...",
        history: "Vēsture",
        currentCar: "Šis auto",
        purchasedCarTitle: "Iegādājās auto",
        initialCost: "Sākotnējā vērtība",
        done: "Gatavs",
        ok: "Labi",
        error: "Kļūda",
        errorSaving: "Kļūda saglabājot datus",
        mandatoryFieldsError: "Lūdzu, aizpildiet visus obligātos laukus korekti.",
        search: "Meklēt",
        milesShort: "jūdzes",
        kmShort: "km",
        invalidEmail: "Nepareizs e-pasta formāts",
        today: "Šodien",
        car: "Auto",
        all: "Visi",
        deleteConfirm: "Dzēst",
        unsavedChangesTitle: "Nesaglabātas izmaiņas",
        unsavedChangesMessage: "Vai vēlaties saglabāt izmaiņas pirms iziešanas?",
        dontSave: "Nesaglabāt",
        additionalOptions: "Papildu iespējas",
        add: "Pievienot",
        fileTooLarge: "Fails ir pārāk liels. Maksimālais izmērs ir {limit} MB.",
        storageFull: "Glabātuves limits pārsniegts. Maksimālā vieta ir {limit} MB.",
        dailyUploadLimit: "Dienas augšupielāžu limits sasniegts ({limit} faili/dienā). Mēģiniet rīt.",
        hourlyUploadLimit: "Stundas augšupielāžu limits sasniegts ({limit} faili/stundā). Mēģiniet pēc stundas.",
        fileCountLimit: "Maksimālais {limit} failu skaits uz vienu vienību.",
        emailParseLimitReached: "E-pastu apstrādes limits sasniegts. Lūdzu, pārejiet uz Pro plānu vai ievadiet čeku manuāli.",
        emailLimitText: "E-pastu apstrādes limits sasniegts.",
        monthlyEmailScans: "E-pastu lasīšana šomēnes",
        lifetimeEmailScans: "E-pastu lasīšana kopā",
        monthlyFileScans: "Čeku/Failu skenēšana šomēnes",
        lifetimeFileScans: "Čeku/Failu skenēšana kopā",
        fileLimitText: "Failu skenēšanas limits sasniegts.",
        planFreeTier: "Bezmaksas līmenis",
        planProTier: "Pro līmenis",
        uploadFailed: "Augšupielāde neizdevās",
        attachments: "Pielikumi",
        limitsAndUsage: "Limiti un lietojums",
        addresses: "adreses",
        emailCopied: "E-pasta adrese nokopēta!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "jūdzes",
        },
        included: "Iekļauts",
        proOnly: "Tikai PRO",
        month: "mēn",
        openInNewTab: "Atvērt jaunā cilnē",
        menu: "Izvēlne",
        home: "Sākums",
        monthsShort: {
            0: "jan",
            1: "feb",
            2: "mar",
            3: "apr",
            4: "mai",
            5: "jūn",
            6: "jūl",
            7: "aug",
            8: "sep",
            9: "okt",
            10: "nov",
            11: "dec",
        },
    },
    carMetadata: {
        bodyType: "Virsbūves tips",
        drivetrain: "Piedziņa",
        transmission: "Ātrumkārba",
        bodyTypes: {
            sedan: "Sedans",
            hatchback: "Hečbeks",
            wagon: "Universālis",
            suv: "SUV / Apvidus",
            crossover: "Krosovers",
            coupe: "Kupeja",
            convertible: "Kabriolets",
            pickup: "Pikaps",
            van: "Minivens",
            commercial: "Komerctransports",
            other: "Cits",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "Priekšpiedziņa",
            rwd: "Aizmugurējā piedziņa",
            awd: "Pilnpiedziņa (4x4)",
            other: "Cits",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manuālā",
            automatic: "Automātiskā",
            cvt: "Variators (CVT)",
            other: "Cits",
        },
        otherLabel: "Cits (norādīt)",
        mileageLabel: "Nobraukums",
    },
    auth: {
        welcome: "Sveicināti",
        welcomeBack: "Sveicināti atpakaļ",
        signIn: "Pieslēgties",
        signInWithGoogle: "Pieslēgties ar Google",
        signOut: "Izrakstīties",
        magicLinkDesc: "Saņemiet piekļuves saiti savā e-pastā",
        magicLinkSent: "Piekļuves saite nosūtīta!",
        magicLinkCheckEmail: "Pārbaudiet savu e-pastu un noklikšķiniet uz saites, lai pieteiktos.",
        emailAddress: "E-pasta adrese",
        getMagicLink: "Saņemiet piekļuves saiti",
        sending: "Sūta...",
        linkSent: "Saite nosūtīta",
        orContinueWith: "Vai turpināt ar",
        googleAccount: "Google kontu",
        newUserNote: "Jauns lietotājs? Jūsu konts tiks izveidots automātiski pēc pirmās veiksmīgās pieteikšanās.",
        magicLinkError: "Neizdevās nosūtīt piekļuves saiti. Lūdzu, pārbaudiet savu e-pastu un mēģiniet vēlreiz.",
        genericError: "Notikusi kļūda. Lūdzu, mēģiniet vēlreiz.",
        projectDescription: "Pārvaldiet savas auto izmaksas, apkopes un vēsturi vienuviet.",
        loginError: "Nevarēja pieslēgties",
        loggingIn: "Pieslēdzas...",
        authenticating: "Autentificēšanās...",
        authenticatingDesc: "Lūdzu, uzgaidiet, kamēr tiek izveidota droša sesija.",
    },
    settings: {
        title: "Iestatījumi",
        systemPreferences: "Sistēmas iestatījumi",
        appSettings: "Lietotnes iestatījumi",
        dangerZone: "Bīstamā zona",
        theme: "Tēma",
        language: "Interfeisa valoda",
        currency: "Valūta",
        units: "Mērvienības",
        distanceUnit: "Attāluma mērvienība",
        volumeUnit: "Tilpuma mērvienība",
        expenseTypes: "Izdevumu veidi",
        expenseTypesDesc: "Pārvaldīt kategorijas",
        categories: "Kategorijas",
        exportData: "Eksportēt datus",
        exportDesc: "Lejupielādēt CSV failu",
        importData: "Importēt datus",
        importDesc: "Atjaunot no CSV rezerves kopijas",
        deleteAccount: "Dzēst kontu",
        deleteAccountDesc: "Neatgriezeniski dzēst visus datus",
        enableSync: "Ieslēgt sinhronizāciju",
        enableSyncDesc: "Sinhronizēt datus starp ierīcēm",
        account: "Konts",
        accountPlan: "Konta plāns",
        carsUsage: "Automašīnas",
        carsLimitReached: "Automašīnu limits sasniegts",
        storageSize: "Mākoņa Atmiņa",
        emailScans: "E-pastu lasīšana",
        fileScans: "Failu (čeku) skenēšana",
        plans: "Plāni",
        currentlyPlan: "Jūsu plāns",
        upgradePlan: "Uzlabot",
        manageSubscription: "Pārvaldīt abonementu",
        nextPayment: "Nākamais maksājums",
        endsOn: "Beidzas",
        adminConsole: "Admina panelis",
        systemControl: "Sistēmas vadība",
        customCategories: "Pielāgotas kategorijas un nosaukumi",
        interfaceTheme: "Dizains (Tēma)",
        light: "Gaišais",
        dark: "Tumšais",
        timezone: "Laika zona",
        timezoneDesc: "Izmanto izdevumu ierakstiem un plānotajiem e-pasta atgādinājumiem",
        timeFormat: "Laika formāts",
        timeFormat24h: "24 stundu (14:30)",
        timeFormat12h: "12 stundu (2:30 PM)",
        kilometers: "kilometri (km)",
        miles: "jūdzes (jūdzes)",
        liters: "litri (l)",
        gallons: "galoni (gal)",
        accountManagement: "Konta pārvaldība",
        contactUs: "Sazināties ar mums",
        contactDesc: "Ieteikumiem, pieprasījumiem un jautājumiem",
        logOut: "Izrakstīties",
        logOutConfirmTitle: "Izrakstīties",
        logOutConfirmMessage: "Vai tiešām vēlaties izrakstīties no konta?",
        keepAccount: "Saglabāt kontu",
        deleteAccountConfirmTitle: "Dzēst kontu",
        deleteAccountConfirmMessage: "Vai tiešām vēlaties neatgriezeniski dzēst savu kontu un visus datus? Šo darbību nevar atsaukt.",
        deletePermanently: "Dzēst neatgriezeniski",
        deleting: "Dzēš...",
        contactSupport: "Sazināties ar atbalstu",
        messageSent: "Ziņa nosūtīta!",
        feedbackThanks: "Paldies par jūsu atsauksmi. Mēs novērtējam jūsu ieguldījumu un izskatīsim to.",
        backToSettings: "Atpakaļ uz iestatījumiem",
        subjectLabel: "Temats",
        messageLabel: "Ziņa",
        subjectPlaceholder: "Par ko ir šī ziņa?",
        messagePlaceholder: "Pastāstiet mums par savu ieteikumu, funkcijas pieprasījumu vai jautājumu...",
        enterSubjectAlert: "Lūdzu, ievadiet tematu",
        enterMessageAlert: "Lūdzu, ievadiet ziņu",
        sendFailedAlert: "Neizdevās nosūtīt ziņu. Lūdzu, mēģiniet vēlreiz vēlāk.",
    },
    api: {
        title: 'API iestatījumi',
        token: 'API tokens',
        generateToken: 'Ģenerēt tokenu',
        rotateToken: 'Rotēt tokenu',
        deleteToken: 'Dzēst tokenu',
        copyToken: 'Kopēt tokenu',
        tokenCopied: 'Tokens nokopēts starpliktuvē',
        noTokenYet: 'Jūs vēl neesat uzģenerējis nevienu API tokenu.',
        rotateWarning: 'Tokena rotācija nekavējoties padarīs iepriekšējo par nederīgu. Visas aplikācijas, kas to izmanto, pārstās darboties.',
        deleteWarning: 'Tokena dzēšana to nekavējoties padarīs par nederīgu.',
        apiUsage: 'API lietojums',
        dailyLimit: 'Dienas limits',
        hourlyLimit: 'Stundas limits',
        endpoints: 'Pieejamie galapunkti',
        docsLink: 'Skatīt pilnu API dokumentāciju',
        keepSafe: 'Glabājiet šo tokenu drošībā. Tam nav beigu termiņa un tas dod pilnu piekļuvi jūsu automašīnu datiem.',
        tokenDesc: 'Izmantojiet šo tokenu, lai strādātu ar savas garāžas datiem caur publisko API vai Jarvis integrācijām.',
    },
    export: {
        title: "Eksportēt datus",
        generatePDF: "Ģenerēt PDF",
        carInformation: "Auto Informācija",
        editInfo: "Rediģējiet informāciju zemāk, lai pielāgotu eksportu",
        editInfoHint: "Jūs varat noņemt vai mainīt laukus, kurus nevēlaties iekļaut",
        filters: "Filtri",
        expenseTypes: "Izdevumu Veidi",
        includeNotes: "Iekļaut Piezīmes",
        includeImages: "Iekļaut Failus",
        hideDisabled: "Slēpt Atspējotos Vienumus",
        itemsCount: "{total} vienumi, {selected} izvēlēti",
        selectAll: "Izvēlēties Visus",
        deselectAll: "Noņemt Izvēli",
        expenses: "Izdevumi",
        notes: "Piezīmes",
        spareParts: "Rezerves detaļas",
        images: "Attēli",
        files: "Faili",
        summary: "Kopsavilkums",
        totalExpenses: "Kopējie Izdevumi",
        totalItems: "Kopā Vienumu",
        generatedOn: "Ģenerēts",
        noItemsSelected: "Eksportam nav izvēlēts neviens vienums",
        noItemsAvailable: "Nav pieejamu vienumu eksportam",
        generating: "Ģenerē PDF...",
        downloadPDF: "Lejupielādēt PDF",
        pdfFileName: "{carName}_eksports_{date}.pdf",
        reportTitle: "Auto Izdevumu Atskaite",
        exportButton: "Eksportēt",
        generateCSV: "Ģenerēt CSV",
        formatSelectorTitle: "Izvēlieties formātu",
        formatSelectorMsg: "Lūdzu, izvēlieties eksportēšanas formātu",
        proFeatureExportTitle: "Pro fīča: Datu eksports",
        proFeatureExportDesc: "Uzlabojiet uz PRO, lai eksportētu savu auto vēsturi uz PDF.",
        exportRestrictedPopup: "Datu eksports ir pieejams tikai Pro lietotājiem.",
        allTypes: "Visi Veidi",
        statistics: "Statistika",
        driven: "Nobraukts",
        since: "Kopš",
        averageCost: "Vidējās Izmaksas",
        perKm: "uz {unit}",
        perMile: "uz jūdzi",
        period: "Periods",
        dateFrom: "No",
        dateTo: "Līdz",
        allTime: "Notīrīt filtru",
        periodHint: "Ja nenorādi periodu — tiek attēloti visi izdevumi",
        noExpenses: "Nav izdevumu, kas atbilst filtriem",
        expensesSection: "Izdevumi",
        attachmentsSection: "Pielikumi",
        imagesCount: "{count} attēli",
        pdfsCount: "{count} PDF",
        includeParts: "Iekļaut rezerves daļas",
        pageLabel: "Lapa",
    },
    expenses: {
        title: "Izdevumi",
        newExpense: "Jauns izdevums",
        editExpense: "Rediģēt izdevumu",
        openExpense: "Atvērt izdevumu ierakstu",
        details: "Izdevuma informācija",
        selectType: "Izvēlēties veidu",
        selectTypePlaceholder: "Izvēlieties izdevumu veidu...",
        shortDescriptionPlaceholder: "Īss apraksts...",
        expenseTitle: "Nosaukums",
        logEntryTitleLabel: "Ieraksta nosaukums",
        defaultTitlePlaceholder: "Noklusējuma nosaukums - {type}",
        autoTitlePlaceholder: "Aizpildīsies automātiski no norādītā izdevumu veida",
        carDataTitle: "Auto dati",
        defaultTitlePrefix: "Pēc noklusējuma būs -",
        addAnother: "Pievienot vēl cita veida izmaksu",
        addAnotherHint: "Ja šī ieraksta ietvaros bija vairāku veidu izmaksas, varat pievienot arī tos, lai auto statistika būtu pareiza.",
        carValueDescription: "Aptuvenā auto tirgus vērtība šajā brīdī.",
        type: "Veids",
        date: "Datums",
        amount: "Summa",
        totalAmount: "Kopā",
        splitCosts: "Atdalīt izmaksas?",
        combineCosts: "Apvienot summu",
        amountWork: "Darbs",
        amountParts: "Rezerves detaļas",
        mileage: "Nobraukums",
        carValue: "Auto vērtība",
        description: "Apraksts",
        detailedDescription: "Apraksts",
        electricity: "Elektrība",
        fuelType: "Degvielas veids",
        fuelTypeOptions: {
            petrol: "Benzīns",
            diesel: "Dīzelis",
            lpg: "Gāze (LPG)",
            electricity: "Elektrība",
        },
        carData: "Auto dati",
        images: "Faili",
        addImages: "Pievienot failus",
        addImagesPDFs: "Pievienot attēlus vai PDF",
        deleteExpense: "Dzēst izdevumu",
        deleteConfirm: "Vai tiešām vēlaties dzēst šo ierakstu?",
        saveSuccess: "Izdevums saglabāts",
        thisExpense: "Šis izdevums",
        stats: {
            annual: "Gada",
            allTime: "Kopā",
            avgMonth: "Vid/Mēn",
            costPer: "Izm/",
            noExpenses: "Vēl nav izdevumu",
            dragToReorder: "Velciet, lai mainītu secību",
        },
        expensesFound: "Izveidots",
        noExpensesFound: "Izdevumi nav atrasti.",
        noDescription: "Nav apraksta",
        imagesCount: "Attēli ({count})",
        deleteImageTitle: "Dzēst attēlu",
        deleteImageConfirm: "Vai tiešām vēlaties dzēst šo attēlu? Šo darbību nevarēs atcelt.",
        typeLabels: {
            fuel: "Degviela",
            car_wash: "Mazgāšana",
            repairs: "Remonts",
            maintenance: "Apkope",
            parts: "Rezerves detaļas",
            insurance: "Apdrošināšana",
            inspection: "Tehniskā apskate",
            tyres: "Riepas",
            parking: "Stāvvieta",
            electricity: "Elektrība",
            taxes: "Nodokļi",
            other: "Citi",
            info: "Informācija",
            service_maintenance: "Apkope",
            service_repair: "Remonts",
            service_tuning: "Tuning",
            tolls: "Maksas ceļi",
        },
        serviceGroup: {
            name: "Serviss",
            selectSubtype: "Izvēlieties veidu",
            maintenance: "Apkope",
            repair: "Remonts",
            tuning: "Tūnings",
        },
        timeLabel: "Laiks",
        addTimeLabel: "Pievienot pulksteņlaiku",
        removeTimeLabel: "Noņemt pulksteņlaiku",
    },
    repeatingExpenses: {
        title: "Atkārtots izdevums",
        repeatToggle: "Atkārtot šo izdevumu",
        repeatFrequency: "Biežums",
        monthly: "Šis izdevums tiks automātiski izveidots katru mēnesi.",
        startDate: "Sākuma datums",
        nextDate: "Nākamais ieraksts tiks ģenerēts",
        endDate: "Beigu datums",
        noEndDate: "Bez beigu termiņa",
        copyOptions: "Atkārtojot šo izdevumu:",
        copyTitle: "Kopēt arī ieraksta nosaukumu",
        copyLocation: "Kopēt arī lokāciju",
        copyDescription: "Kopēt arī aprakstu",
        active: "Aktīvs",
        status: "Statuss",
        managedByRepeat: "Šis izdevums ir daļa no atkārtotas secības.",
        placeholder: "Šeit varat iestatīt automātisku šī izdevuma atkārtošanu, ja tas paredzēts regulāri ar tādu pašu summu.",
        deleteRepeat: "Dzēst atkārtošanu",
        deleteRepeatConfirm: "Vai tiešām vēlaties pārtraukt un dzēst šo atkārtošanos? Nākamie ieraksti netiks ģenerēti. Iepriekšējie ieraksti paliks.",
        relatedEntries: "Ieraksti šajā secībā",
        stopRepeat: "Pārtraukt atkārtošanu",
        isRepeating: "Atkārtojas",
        noTerm: "Bez termiņa",
        until: "Pēdējais ieraksts tiks ģenerēts",
        summaryCopy: "Sistēma pārkopēs",
        simulate: "Simulēt nākamā ieraksta izveidi",
        simulateSuccess: "Nākamā ieraksta simulācija veiksmīga",
        simulateNoDate: "Vairs nav datumu ko ģenerēt (beigu termiņš sasniegts)",
    },
    onboarding: {
        title: "Profila iestatīšana",
        welcome: "Sveicināti!",
        subtitle: "Pielāgojiet savu lietošanās pieredzi.",
        currency: "Valūta",
        preferredCurrency: "Vēlamā valūta",
        distUnit: "Attāluma mērvienība",
        volUnit: "Tilpuma mērvienība",
        complete: "Pabeigt",
    },
    cars: {
        unitChangeWarningTitle: "Vienību maiņas brīdinājums",
        unitChangeWarningMessage: "Vienību maiņa nekonvertēs esošos datus. Visi vēsturiskie ieraksti paliks tieši tādi, kādi tie tika ievadīti.",
        unitChangeWarningConfirm: "Sapratu",
        title: "Garāža",
        carAdmins: "Automašīnas administratori",
        sharedWithMe: "Koplietots ar mani",
        manageAdmins: "Pārvaldīt administratorus",
        adminEmail: "Administratora e-pasts",
        addAdmin: "Pievienot administratoru",
        addAdminPlaceholder: "piemēram, draugs@epasts.lv",
        removeAdmin: "Noņemt",
        removeAdminConfirm: "Vai tiešām vēlaties noņemt šo administratoru?",
        adminAdded: "Administrators pievienots",
        adminRemoved: "Administrators noņemts",
        removeMyAccess: "Noņemt manu piekļuvi",
        removeMyAccessConfirm: "Vai tiešām vēlaties atteikties no piekļuves šai automašīnai?",
        myAccessRemoved: "Piekļuve noņemta",
        noAdminsYet: "Pagaidām nav pievienots neviens administrators.",
        adminInfoText: "Administratori var pievienot un rediģēt izdevumus, piezīmes un detaļas, bet nevar dzēst pašu automašīnu.",
        newCar: "Pievienot auto",
        carNotFound: "Auto nav atrasts",
        carNotFoundDesc: "Pieprasītā automašīna neeksistē vai jums nav piekļuves.",
        accessDenied: "Piekļuve liegta",
        accessDeniedDesc: "Šī automašīna ir privāta un nav publiski pieejama.",
        backToHome: "Atpakaļ uz sākumlapu",
        adminRestricted: "Piekļuve ierobežota",
        adminRestrictedDesc: "Tikai pilnvaroti administratori var piekļūt šai konsolē. Lūdzu, atgriezieties pie galvenās lietojumprogrammas.",
        returnHome: "Atgriezties mājās",
        editCar: "Rediģēt auto",
        name: "Nosaukums",
        model: "Modelis",
        year: "Gads",
        plate: "Numura zīme",
        vin: "VIN numurs",
        mileage: "Pašreizējais nobraukums",
        initialMileage: "Sākuma nobraukums",
        engineType: "Dzinēja tips",
        tapToChangeIcon: "Pieskarieties, lai mainītu ikonu",
        chooseIcon: "Izvēlēties ikonu",
        imageTab: "Attēls",
        iconTab: "Ikona",
        chooseColor: "Izvēlēties krāsu",
        chooseEmoji: "Izvēlēties emocijzīmi",
        uploadImage: "Augšupielādēt attēlu",
        clickToBrowse: "Noklikšķiniet, lai pārlūkotu failus",
        currentCarIcon: "Pašreizējā automašīnas ikona",
        changeImage: "Mainīt attēlu",
        zoom: "Tuvojums",
        rotate: "Griezt",
        removeChangeImage: "Noņemt / Mainīt attēlu",
        selectIcon: "Izvēlēties ikonu",
        cropAndSave: "Izgriezt un saglabāt",
        displayName: "Nosaukums",
        displayNamePlaceholder: "piemēram, Mans darba auto",
        makeLabel: "Marka *",
        modelLabel: "Modelis *",
        yearLabel: "Gads *",
        fuelTypeLabel: "Degvielas veids *",
        licensePlateLabel: "Numura zīme",
        vinLabel: "VIN",
        notesLabel: "Piezīmes",
        notesPlaceholder: "piem., 1.6 TDI, 85kW, 1588cc, bat. 62kWh, AWD u.c.",
        publicAccess: "Padarīt auto publiski pieejamu",
        publicAccessDesc: "Citi varēs apskatīt šo auto caur kopīgotu saiti",
        shareLocations: "Atļaut publiski redzēt arī pievienotās lokācijas",
        shareLocationsDesc: "Ieslēdziet šo, lai padarītu auto lokācijas redzamas publiskajā skatā",
        deleteCar: "Dzēst auto",
        deleteCarTitle: "Dzēst auto",
        deleteCarConfirm: "Vai tiešām vēlaties dzēst '{name}'? Šo darbību nevarēs atcelt.",
        noCars: "Garāža ir tukša",
        addFirstCarNote: "Pievienojiet savu pirmo auto, lai sāktu sekot līdzi izdevumiem.",
        addVehicle: "Pievienot auto",
        myVehicles: "Mani auto",
        favorites: "Favorīti",
        deleteConfirm: "Vai tiešām vēlaties dzēst šo auto? Visi saistītie izdevumi tiks dzēsti.",
        deleteFailed: "Neizdevās dzēst auto",
        saveFailed: "Neizdevās saglabāt auto datus",
        adminActions: "Admin darbības",
        importCsv: "Importēt CSV",
        clearData: "Dzēst datus",
        distanceUnitLabel: "Attāluma mērvienība",
        volumeUnitLabel: "Tilpuma mērvienība",
        currencyLabel: "Valūta",
        boughtAt: "Iegādes datums",
        purchasePrice: "Iegādes cena",
        purchaseMileage: "Nobraukums iegādes brīdī",
        createPurchaseRecord: "Automātiski izveidot iegādes ierakstu vēsturē",
        makePlaceholder: "piem., BMW",
        modelPlaceholder: "piem., X5",
        platePlaceholder: "piem., AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Šī informācija izveidos 'Informācija' ierakstu auto vēsturē ar norādītajiem datiem.",
        availableTypes: "Pieejamie veidi",
        dragToReorder: "Velc, lai pārkārtotu",
        requestTypeNote: "Ja nepieciešams vēl kāds tips - ",
        requestTypeAction: "dod ziņu!",
        emailProcessingTitle: "E-pastu apstrāde",
        emailInstructions: "Pārsūtiet savus čekus uz zemāk norādīto adresi. Mēs izgūsim datus un automātiski izveidosim izdevumus.",
        recentEmails: "Saņemtie e-pasti",
        viewAllEmails: "SKATĪT VISUS ({count})",
        noEmailsReceived: "E-pasti vēl nav saņemti.",
        analysisResult: "Analīzes rezultāts",
        vehicleInfo: "Auto informācija",
        preferences: "Iestatījumi",
        purchaseHistory: "Iegādes vēsture",
        emailProcessing: "E-pastu apstrāde",
        publicAccessTitle: "Publiskā piekļuve",
        expenseTypesTitle: "Izdevumu veidi",
        adminActionsTitle: "Admin darbības",
        enterPurchaseDateAlert: "Lūdzu, ievadiet iegādes datumu",
        allowedSenderEmails: "Atļautās sūtītāju e-pasta adreses",
        allowedEmailsDesc: "Pievienojiet e-pasta adreses, kuras drīkst sūtīt kvītis uz šo automašīnu. Maksimāli 5 adreses.",
        noAllowedEmails: "Nav pievienotas atļautas e-pasta adreses.",
        emailAlreadyAdded: "Šī e-pasta adrese jau ir atļauta šai automašīnai.",
        maxAllowedEmailsReached: "Sasniegts maksimālais atļauto e-pasta adresu limits.",
        addAllowedEmailPlaceholder: "Pievienot atļauto e-pasta adresi...",
        ownerEmail: "Īpašnieks",
        onlyOwner: "tikai īpašnieks",
        defaultAllowed: "Vienmēr atļauts",
        carLimitReachedTitle: "Automašīnu limits sasniegts",
        carLimitReachedMessage: "Jūsu {plan} plāns atļauj {limit} automašīnu(-as). Jums jau ir {current}. Dodieties uz iestatījumiem, lai redzētu savus limitus vai sazinieties ar mums, lai uzlabotu plānu.",
        carLimitGoToSettings: "Uz Iestatījumiem",
        archivedCars: "Arhivētie",
        archiveCar: "Arhivēt auto",
        unarchiveCar: "At-arhivēt auto",
        sellDate: "Pārdošanas datums",
        sellPrice: "Pārdošanas cena",
        sellMileage: "Pārdošanas nobraukums",
        archiveConfirm: "Vai tiešām vēlaties arhivēt šo auto?",
        archiveInstructions: "Auto arhivēšana nozīmē, ka tas vairs nav jūsu, vai arī jūs to vairs neuzturat. Lūdzu, ievadiet pārdošanas detaļas statistikai. Pēc arhivēšanas auto būs pieejams tikai lasīšanas režīmā. Zemāk minētos laukus varēs pēc tam vēl mainīt.",
        archivedBadge: "Arhivēts",
        saleDetails: "Pārdošanas dati",
        saleDetailsNote: "Pārdošanas dati tiek izmantoti statistikai. Tos var mainīt arī vēlāk.",
        archiveDetailsNotFillable: "Lūdzu, aizpildiet visus laukus, lai arhivētu auto",
        emailAddressWillBeAvailableAfterSave: "E-pasta adrese būs pieejama pēc auto saglabāšanas.",
        proFeatureAdminTitle: "Pro iespēja: Auto administratori",
        proFeatureAdminDesc: "Pievienojiet citus lietotājus, kuri varēs skatīt un pārvaldīt šo auto datus.",
        proFeatureEmailTitle: "Pro iespēja: Papildus sūtītāji",
        proFeatureEmailDesc: "Pievienojiet citas atļautās e-pasta adreses, no kurām drīkst sūtīt čekus uz šo auto.",
        estimatedMileage: "Provizoriskais nobraukums",
        summaryFrequencyLabel: "Kopsavilkumu biežums",
        summaryFrequencyOptions: {
            none: "Izslēgts",
            monthly: "Reizi mēnesī",
            semiAnnually: "Reizi pusgadā",
            annually: "Reizi gadā",
        },
        healthProfilePrompt: "Papildi veselības profilu precīzākai analīzei!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzīns",
        diesel: "Dīzelis",
        hybrid: "Hibrīds",
        electric: "Elektro",
        lpg: "Gāze (LPG)",
    },
    statistics: {
        mileageTrend: "Nobraukuma TENDENCE",
        title: "Statistika",
        allYears: "Visi gadi",
        totalSpent: "Kopā iztērēts",
        spentIn: "Iztērēts {year}. gadā",
        perMonth: "mēnesī",
        overall: "kopā",
        vsPrev12m: "pret iepr. 12m",
        rolling12m: "Pēdējie 12m",
        byType: "Pa veidiem",
        byMonth: "Pa mēnešiem",
        byYear: "Pa gadiem",
        noData: "Nav datu par šo gadu",
        mostExpensive: "Dārgākie",
        top: "Augšējais",
        untitled: "Bez nosaukuma",
        assetAnalysis: "Vērtības un izmaksu analīze",
        burnNote: "* 'Kopējais patēriņš' ietver gan iztērēto naudu, gan aplēsto auto vērtības samazinājumu.",
        carMarketValue: "Auto tirgus vērtība",
        cumulativeCosts: "Uzkrātās izmaksas",
        totalBurn: "Kopējais patēriņš (Izmaksas + Nolietojums)",
        entries: "ieraksti",
        avgPrice: "Vidējā cena",
        consumption: "Patēriņš",
        price: "Cena",
        fuelPriceTrend: "Degvielas cenas tendence",
        spendingTrend: "Izdevumu tendence",
        costPerKmTrend: "Izmaksas uz 1 {unit}",
        costPerMileTrend: "Izmaksas uz 1 jūdzi",
        serviceTrendsTitle: "Servisa izdevumu tendences",
        expensesOnMap: "Izdevumi kartē",
        visitsCountLabel: "vizītes",
        locationsSummary: "Lokāciju kopsavilkums",
        locationsCountLabel: "vietas",
        noLocationsFoundTitle: "Vēl nav lokāciju",
        noLocationsFoundDesc: "Pievieno lokācijas saviem ierakstiem, lai tās redzētu šeit.",
        addMileageData: "Pievienot nobraukumu",
        missingMileageInfo: "Nepietiek datu, lai aprēķinātu izmaksas uz {unit}. Pievieno vismaz 2 nobraukuma rādījumus šajā periodā (vai vienu pirms šī perioda).",
        mileageModal: {
            title: "Papildināt nobraukumu",
            description: "Lai precīzi aprēķinātu izmaksas uz {unit} {year}. gadam, nepieciešams zināt nobraukumu gada sākumā un beigās.",
            startOfYear: "Gada sākumā (01. janvārī)",
            endOfYear: "Gada beigās (31. decembrī)",
            currentMileage: "Tekošais nobraukums",
            placeholder: "Ievadiet nobraukumu...",
            save: "Saglabāt datus",
            foundNearby: "Atrasts tuvumā ({date}): {value} {unit}",
            useExisting: "Izmantot šo",
        },
        proAnalysis: "Pro analīze",
        detailedAnalysis: "Detalizēta analīze",
        upgradeToSee: "Uzlabot, lai redzētu →",
    },
    blog: {
        latestPosts: 'Jaunākais no bloga',
        morePosts: 'Skatīt visus rakstus',
        readMore: 'Lasīt vairāk',
        readArticle: 'Lasīt rakstu',
        back: 'Atpakaļ',
        backToBlog: 'Atpakaļ uz blogu',
        share: 'Dalīties:',
        checkMath: 'Pārbaudi savus datus',
        resourceCenter: 'Resursu Centrs',
        noMorePosts: 'Pagaidām jaunu rakstu nav. Sekojiet līdzi!',
        keepReading: 'Citi raksti',
        title: 'Resursu Centrs',
        subtitle: 'Mēs nedzim jaunu "Excel". Mēs būvējam resursu centru, lai palīdzētu jums pieņemt labākus lēmumus par savu auto.'
    },
    tabs: {
        dashboard: "Pārskats",
        expenses: "Izdevumi",
        stats: "Statistika",
        locations: "Lokācijas",
        gallery: "Faili",
        parts: "Rezerves detaļas",
        notes: "Piezīmes",
        repair: "Auto veselība",
        'repair-switch': "Auto maiņa",
    },
    repairAnalysis: {
        title: "Remonta lēmuma analīze",
        ownershipLength: "Īpašuma ilgums",
        currentValue: "Pašreizējā vērtība",
        valueOutdated: "Vērtība varētu būt neaktuāla",
        addValueToEnable: "Pievienojiet auto vērtību, lai iespējotu analīzi",
        totalInvested: "Kopā ieguldīts",
        totalInvestedSub: "Iegāde + visi remonti *",
        totalExcludesFuel: "bez degvielas / elektrības",
        fuelLabelFuelOnly: "Degviela kopā",
        fuelLabelEnergyOnly: "Enerģija kopā",
        fuelLabelHybrid: "Degviela & Enerģija kopā",
        fuelTypeFuel: "degvielas",
        fuelTypeEnergy: "elektrības",
        fuelTypeHybrid: "degvielas un elektrības",
        fuelTotalLabel: "Degviela/Enerģija kopā:",
        projectionMode: "Prognozes veids",
        projectionModes: {
            lastYear: "Pēc pēdējā gada",
            average: "Vidējais (vēsturiskais)",
            trend: "Tendence (lineāra)",
        },
        brakeAssumption: "Iekļauta bremžu apkope (~reizi 3 gados)",
        repairBuffer: "Iekļauts vecuma riska buferis remontiem",
        yearLabel: "gads",
        totalInvestedDesc: "Iegādes cena + visi remonti",
        repairToValue: "Remonti pret vērtību (12m)",
        repairToValueExplain: "Remontu izmaksas €{cost} pret auto vērtību €{value}. Līdz 20% ir veselīgi; virs 50% — augsts risks.",
        ownershipPressure: "Īpašuma spiediens",
        ownershipPressureExplain: "Kopējais spiediens: remonti €{cost} + vērtības kritums vs auto vērtība €{value}. Virs 35% rakštanot vai nu augstu risku vai finansiālu stresu.",
        investmentGap: "Ieguldījumu starpība",
        investmentGapExplain: "Kopā ieguldzits €{invested} mīnus pāšreizeja vērtība €{value} — cik daudz Jus līdz šim ‘zaudējāt’ uz īpšumu.",
        investmentGapDesc: "Kopā ieguldīts - pašreizējā vērtība",
        repairExpenses12m: "12m remonta izmaksas",
        calculatedYearlyMileage: "Aprēķināts gada nobraukums: {km} {unit}",
        calculatedYearlyRepairs: "Aprēķinātās remonta izmaksas gadā: {amount}",
        set: "Uzstādīt",
        plannedRepairCost: "Plānojamo remontu izmaksas",
        whatIfTitle: "Ko ja jūs iztērētu {amount} tagad?",
        updatedScore: "Atjaunots rezultāts",
        updatedVerdict: "Atjaunots spriedums",
        howIsItCalculated: "Kā tas tiek aprēķināts?",
        usedLifespan: "Izmantots: {usage}% no paredzētā mūža",
        remainingLifespan: "Atlicis: ~{km} {unit}",
        estimatedLifespan: "Paredzamais mūžs: {km} {unit}",
        lifecycle_stage_early: "Dzīves cikla sākums – zems lielo bojājumu risks",
        lifecycle_stage_mid: "Dzīves cikla vidus – normāls nolietojums",
        lifecycle_stage_late: "Dzīves cikla beigu posms – paaugstināts remontu risks",
        lifecycle_stage_end: "Paredzamā mūža beigas – augsts lielo remontu risks",
        calculationExplanation: "Analīze izmanto jūsu auto iegādes cenu, pēdējos remonta izdevumus un aplēsto pašreizējo vērtību, lai aprēķinātu finansiālās veselības rādītāju. Augstas remonta izmaksas pret auto vērtību vai strauja vērtības samazināšanās pazeminās šo rādītāju.",
        confidenceLabel: "Precizitāte",
        confidenceLevel: {
            high: "Augsta",
            medium: "Vidēja",
            low: "Zema",
        },
        mentalFactorsTitle: "Uzlabojiet precizitāti ar savu pieredzi",
        mentalFactorsCTA: "Ātrā aptauja (30 sek)",
        mentalFactorsSurveyTitle: "Jūsu viedoklis",
        mentalFactorsSurveyDesc: "Atbildiet uz 3 īsiem jautājumiem, lai personalizētu rezultātu.",
        q1: "Vai auto apmierina jūsu vajadzības?",
        q1Help: "Vieta, komforts, funkcijas",
        q2: "Vai jums patīk braukt ar šo auto?",
        q2Help: "Vizuālais, komforts, sajūta",
        q3: "Vai uztraucaties par neplānotiem remontiem?",
        q3Help: "Rūpes par uzticamību",
        q4: "Vai šis auto paredzēts ģimenei un tāliem braucieniem?",
        q4Help: "Drošības un uzticamības prioritāte",
        factorsTitle: "Rezultāta Faktori",
        factorsDesc: "Apskatiet, kas ietekmē jūsu rezultātu",
        newCarComparison: "Jauna Auto Salīdzinājums",
        newCarComparisonDesc: "Salīdziniet savas pašreizējās izmaksas ar jauna auto iegādi.",
        modeLeasing: "Līzings",
        modeFullPrice: "Pilna Cena",
        downPayment: "Pirmā iemaksa",
        leaseYears: "Termiņš (Gadi)",
        monthlyPayment: "Ikmēneša maksājums",
        carPrice: "Auto Pilnā Cena",
        ownershipYears: "Plānotais īpašums (gadi)",
        insuranceMonthly: "Mēneša KASKO / Apdrošināšana",
        currentMonthlyCost: "Pašreizējās Izmaksas",
        newCarMonthlyCost: "Jauna Auto Izmaksas",
        newCarCheaper: "Jauns auto ir lētāks par: {amount} / mēn",
        newCarMoreExpensive: "Jauns auto ir dārgāks par: {amount} / mēn",
        newCarSameCost: "Izmaksas ir pilnīgi vienādas.",
        advancedSettings: "Papildu iestatījumi",
        yearlyMaint: "Gada apkope (€)",
        tyres3Yrs: "Riepas / 3 gados (€)",
        depreciation5Yrs: "Vērtības kritums (5 gadi, %)",
        newCarYear: "Jaunā auto gads",
        cumulativeCosts: "Kumulatīvās izmaksas (projekcija)",
        comparisonByYear: "Salīdzinājums pa gadiem",
        currentCarLabel: "Esošais auto",
        newCarLabel: "Jauns auto",
        resaleValue: "Pārdošanas vērtība",
        startupCosts: "Sākuma izmaksas (lietots auto)",
        inspection: "Pirms-pirkuma pārbaude",
        initialMaintenance: "Pirmā apkope + eļļas",
        registration: "Reģistrācija / CSDD",
        total: "Kopā",
        currentCarTitle: "Esošais auto",
        newCarTitle: "Potenciālais auto",
        upfrontInvestment: "Sākotnējais ieguldījums",
        monthlyReality: "Reālā mēneša maksa",
        depreciationShort: "Vērtības kritums",
        howCalculated: "Kā tas aprēķināts?",
        deltaMonthly: "Starpība mēnesī",
        deltaUpfront: "Starpība uzreiz",
        surveyMeanings: {
            practical: {
                1: "Pavisam neatbilst",
                2: "Drīzāk neatbilst",
                3: "Vidēji",
                4: "Labi atbilst",
                5: "Ideāli atbilst",
            },
            joy: {
                1: "Apmierinājums",
                2: "Garlaicīgi",
                3: "Vidēji",
                4: "Patīkami",
                5: "Ļoti patīkami",
            },
            worry: {
                1: "Nav uztraukts",
                2: "Nedaudz uztraukts",
                3: "Uztraukts",
                4: "Ļoti uztraukts",
                5: "Noteikti drīz sabojāšos",
            },
        },
        verdicts: {
            KEEP: "Finansiāli racionāli paturēt",
            borderline: "Robežgadījums – vērojiet uzmanīgi",
            sell: "Augsts finansiāls risks – pārdošana varētu būt racionāla",
        },
        factors: {
            trendInc: "Pieaugoša Tendence",
            trendIncDesc: "Remonta izmaksas pieaug, salīdzinot ar pagājušo gadu.",
            lowDepreciation: "Zema Vērtības Zuduma Priekšrocība",
            lowDepreciationDesc: "Vecāki un lētāki auto laika gaitā zaudē mazāk vērtības.",
            stableRepairs: "Remontu izmaksu svārstības",
            stableRepairsDesc: "Kā mainās remonta izmaksas pret iepriekšējo gadu.",
            noHistoricalData: "Nav datu, kas vecāki par 6 mēnešiem.",
            lifecycle_stage: "Auto dzīves cikla posms",
            high_risk_phase: "Augsta riska fāze",
            high_risk_phase_desc: "Vēlīna dzīves cikla posma un pieaugošo remonta izmaksu kombinācija norāda uz augstu risku.",
            lowCostKm: "Efektīvas izmaksas par {unit}",
            lowCostKmDesc: "Kopējā šī auto ekspluatācijas efektivitāte ir lieliska.",
            lowFixedCosts: "Zemas fiksētās izmaksas",
            lowFixedCostsDesc: "Jūsu fiksētās izmaksas (nodokļi, apdrošināšana) ir zemas.",
            usage: "Gada lietojums",
            usageDesc: "Attālums, kas nobraukts pēdējo 12 mēnešu laikā.",
            accidentMinor: "Neliels negadījums",
            accidentMinorDesc: "Vizuāli vai sīki bojājumi.",
            structuralDamage: "Strukturāls Bojājums",
            structuralDamageDesc: "Bojājums rāmī vai nesošajās virsmās krasi samazina vērtību.",
            aiLifespanNearEnd: "Dzīves Cikla Beigas",
            aiLifespanAging: "Nolietošanās Risks",
            aiLifespanGood: "Nobraukuma Priekšrocība",
            aiLifespanDesc: "Balstoties uz AI aprēķiniem par šī modeļa tipisko dzīves ciklu.",
            aiUpcomingRepairs: "Plānojamie AI remonti",
            aiUpcomingRepairsDesc: "Sagaidāmi specifiski šī modeļa defekti pēc nobraukuma.",
            ownershipFatigue: "Īpašuma ilguma nogurums",
            ownershipFatigueLong: "Ilgstošs īpašuma periods bieži rada psiholoģisku gatavību jaunam auto.",
            ownershipFatigueShort: "Sākotnējais īpašuma periods veicina lielāku vēlmi auto paturēt.",
            family_priority: "Ģimenes braucieni & drošība",
            replacement_comparison: "Jauna auto salīdzinājums",
            none: "Nav",
            surface: "Virsmas",
            minor: "Neliela",
            moderate: "Vidēja",
            severe: "Smaga",
            structural: "Strukturāla",
            major: "Nopietna",
            critical: "Kritiska",
            full: "Pilna",
            improveLabel: "Kas uzlabotu rezultātu:",
            info_original_price: "Aptuvenā cena šim auto, kad tas bija jauns. Palīdz novērtēt vērtības stabilitāti. Vecāki auto ar zemāku atlikušās vērtības ir finansiāli drošāki.",
            info_current_value: "Cik daudz jūs varētu to pārdot šodien. Izmanto, lai pārbaudītu, vai remonti ir liela procentuālā daļa no auto vērtības, kas signalizē par sliktu ieguldījumu.",
            info_yearly_mileage: "Augstāks nobraukums palielina nodilumu. Zems nobraukums var ievērojami pagarināt auto kalpošanas laiku.",
            info_estimated_repairs: "Pastāvīgās izmaksas, lai uzturētu auto darba kārtībā. Augstas ikgadējās izmaksas samazina auto saglabāšanas pievilcību.",
            info_planned_repairs: "Zināmie gaidāmie remonti. Simulē tūlītēju spiedienu uz jūsu lēmumu.",
            info_ownership_years: "Cik ilgi jūs esat īpašnieks šim auto? Tas ietekmē psiholoģisko īpašuma nogurumu un sākotnējo pircēja aizspriedumu.",
            info_rust: "Kritiska ilgtermiņa riska faktors. Strukturāla rūsēšana samazina drošību. Smaga rūsēšana padara pārdošanu par labāku iespēju.",
            info_crashes: "Strukturāli negadījumi ietekmē drošību un uzticamību. Tie arī ievērojami samazina pārdošanas vērtību.",
            info_repaint: "Signalizē par iepriekšējiem bojājumiem vai kosmētiskām remontiem. Mazs ietekmes līmenis, ja dziļāki jautājumi tika slēpti.",
            info_unresolved: "Slēptas nākotnes izmaksas. Zināmas kļūdas elektronikā, dzinējā vai apkopē, kurām nepieciešama uzmanība.",
            info_fit: "Vai auto atbilst jūsu vajadzībām (telpa, komforts)? Slikta atbilstība nozīmē, ka jūs, visticamāk, to nomainīsiet.",
            info_joy: "Emocionālā vērtība ir svarīga. Ja nav prieka, jūs esat psiholoģiski gatavs jaunam auto.",
            info_worry: "Percepcijas uzticamības stress. Augsts uztraukums ir spēcīgs signāls nomainīt auto.",
        },
        explanations: {
            repairFreq: "Jūsu auto pēdējos 12 mēnešos bija {visits} servisa apmeklējumi. Bieži apmeklējumi norāda uz zemāku uzticamību.",
            repairVsValue: "Pēdējā gada laikā remontu izmaksas sasniedza €{cost}, kamēr auto vērtība ir aptuveni €{value}. Tie ir {ratio}% no auto kopējās vērtības.",
            stableRepairsDetailYearly: "Pēdējā gadā remontos iztērējāt €{cost1}, bet gadu iepriekš €{cost2}. Izmaiņa par {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "Pēdējā pusgadā €{cost1}, iepriekšējā pusgadā €{cost2}. Izmaiņa par {percent}% ({trend}).",
            mileage: "Pie {mileage} {unit} auto sasniedz paaugstināta riska zonu lieliem bojājumiem (ātrumkārba, dzinēja detaļas).",
            planned: "Jums ir €{cost} plānotajos remontos, kas nekavējoties samazina finansiālo drošību auto saglabāšanā.",
            lowDep: "Auto, kuru vērtība ir ap €{value}, zaudē ļoti maz vērtības gadā, līdzsvarojot augstākas remonta izmaksas.",
            depRisk: "Jūsu auto ir {age} gadus vecs un lielākoties ir pabeidzis savu nolietojuma ciklu, kas nozīmē, ka jūs nezaudējat naudu tā vērtības kritumā.",
            stable: "Šogad jūs iztērējāt €{costThisYear} salīdzinājumā ar €{costLastYear} pagājušajā gadā, kas ir {percent}% samazinājums. Prognozējamas izmaksas ir matemātiski izdevīgas.",
            costKm: "Pēdējā gadā nobraucāt {km} {unit}. Ekspluatācijas izmaksas (remonti) sastādīja €{costKm} uz {unit}, kas ir ļoti ekonomiski.",
            fixedCosts: "Fiksētās izmaksas (apdrošināšana, nodokļi) bija €{costs}. Šādas zemas fiksētās izmaksas atslogo auto uzturēšanu.",
            usage: "Lietojums balstās uz jūsu norādīto vai aprēķināto vidējo nobraukumu: {km} {unit} gadā.",
            practical_fit: "Praktiskumu novērtējāt ar {score}/5, tādējādi izmainot rezultātu par {impact} punktiem.",
            emotional_satisfaction: "Emocionālo apmierinātību novērtējāt ar {score}/5, mainot rezultātu par {impact} punktiem.",
            reliability_anxiety: "Jūsu reālā paļauvība uzticamībai ir atzīmēta kā {score}/5, ietekmējot rezultātu par {impact} punktiem.",
            rust: "Ilgstoša vai nopietna korozija nozīmē dārgus metināšanas darbus un ir drošības apdraudējums.",
            accident: "Iepriekšēji bojājumi slēpti ietekmē vērtību un ilgtermiņa tehnisko uzticamību.",
            structural: "Strukturāli bojājumi, rāmja deformācijas vai plūdu sekas padara auto finansiāli un fiziski bīstamu uzturēšanai.",
            ai_lifespan: "Pie {current} {unit} auto ir sasniedzis {ratio}% no AI paredzētā dzīves cikla ({expect} {unit}) šim modelim.",
            ai_repairs: "AI dati rāda, ka {count} biežāko lielo remontu defekti šim modelim sakrīt vai tuvojas jūsu nobraukumam.",
            lifecycle_stage: "Ko nozīmē lifespan? {total} {unit} – šis ir AI prognozētais brīdis, kad šim modelim parasti sākas lieli strukturāli remonti (dzinējs, ātrumkārba, u.c.). Tas nav auto dzīves beigas – auto var braukt tālāk, bet ar ievērojamu lielākām uzturēšanas izmaksām. Tipiskā auto pilnā fiziskā lifespan ir 500k–1M {unit}, bet ekonomiski tas kļūst neizdevīgs daudz agrāk.",
        },
        ratios: {
            healthy: "Veselīgi",
            monitor: "Uzraudzīt",
            highRisk: "Augsts risks",
            stable: "Stabils",
            warning: "Brīdinājums",
            financialStress: "Finansiāls stress",
        },
        proFeatureTitle: "Pro funkcija: Remonta režīms",
        proFeatureDesc: "Atveriet lēmumu dzinēju, lai iegūtu profesionālu finanšu analīzi par jūsu transportlīdzekļa remontiem. Bezmaksas lietotāji redz demonstrāciju ar paraugiem datiem.",
        viewDemo: "Skatīt tiešraides demonstrāciju",
        upgradeToUnlock: "Jauniniet uz PRO, lai analizētu savu automašīnu",
    },
    carTasks: {
        title: "Auto uzdevumi",
        placeholderTitle: "Tehniskās apkopes uzskaite",
        placeholderDesc: "Apkopes grafiks jūsu auto modelim.",
        demoTitle: "Auto apkopes uzdevumi",
        demoSubtitle: "Viedā uzskaite jūsu auto",
        feature1Title: "Automātiska uzdevumu ģenerēšana",
        feature1Desc: "Automātiski ģenerē uzdevumus kā eļļas maiņa, filtru maiņa un zobsiksnas pārbaude, balstoties uz jūsu auto modeli.",
        feature2Title: "Integrācija ar izdevumiem",
        feature2Desc: "Analizē jūsu servisa vēsturi, lai saprastu, kas jau ir izdarīts un kad.",
        feature3Title: "Viedie atgādinājumi",
        feature3Desc: "Saņemiet paziņojumus gan pēc laika, gan nobraukuma. Uzskaite atiestatās automātiski, kad atzīmējat uzdevumu kā pabeigtu.",
        getStarted: "Sākt lietot",
        fakeDoorPopupTitle: "Gaidām atsauksmes",
        fakeDoorPopupMessage: "Šobrīd izstrādājam auto apkopes uzdevumus. Šī fīča ļaus automātiski sekot servisa intervāliem. Kas tieši no tā jūs interesētu visvairāk?",
        fakeDoorPopupPlaceholder: "Jūsu domas...",
        noTasksYet: "Pagaidām nav neviena uzdevuma",
        deleteAllTitle: "Notīrīt uzdevumu sarakstu?",
        deleteAllMessage: "Vai tiešām vēlaties izdzēst visus {count} uzdevumus šim auto? Šo darbību nevar atcelt.",
        deleteAllSuccess: "Visi uzdevumi ir veiksmīgi izdzēsti.",
        sortPriority: "Prioritāte",
        sortType: "Tips",
        sortDate: "Jaunākie",
        status: {
            overdue: "AIZKAVĒJIES",
            pending: "GAIDA",
            noData: "NAV DATU",
            upcoming: "Nākamie",
            nextIn: "Nākamais pēc {dist} {unit}",
            overdueBy: "{dist} {unit} aizkavēts",
            afterDays: "Pēc {days} dienām",
            overdueDays: "{days} dienas aizkavēts",
        },
        form: {
            newTitle: "Jauns uzdevums",
            actionType: "Pārbaudīt vai nomainīt?",
            intervalMonths: "Intervāls (Mēneši)",
            intervalDistance: "Intervāls (Attālums)",
            diffFirstInterval: "Pirmais intervāls atšķiras no pamata intervāla",
            firstInterval: "Pirmais intervāls",
            historyToggle: "Vai šis uzdevums kādreiz ir veikts šim auto?",
            historyToggleDesc: "Ja NĒ, mēs pieņemam, ka tas nekad nav veikts kopš ražošanas.",
            lastPerformedOptional: "Kad tas pēdējo reizi tika veikts? (Pēc izvēles)",
            deleteTitle: "Izdzēst uzdevumu",
            deleteConfirm: "Vai tiešām vēlaties izdzēst šo uzdevumu?",
            saveError: "Neizdevās saglabāt uzdevumu",
            historyConfirmed: "Vēsture apstiprināta",
            reminders: "Atgādinājumi",
            notifyMileage: "Paziņot, kad tiek sasniegts paredzamais nobraukums",
            notifyDate: "Paziņot, kad tiek sasniegts datums",
            nextMileageReminder: "Nākamais mērķis",
            nextDateReminder: "Plānotais datums",
            estimatedDate: "Prognozētais datums",
            missingLastMileage: "Trūkst informācija par pēdējo apkopes nobraukumu",
            missingLastDate: "Trūkst informācija par pēdējo apkopes datumu",
            missingStartDate: "Neizdevās noteikt sākuma datumu",
            additionalOptions: "Papildu opcijas",
            reminderInfoMissing: "Informācijas stāvoklis: atgādinājumi ir atslēgti, līdz tiek sniegti pēdējie veiktie dati.",
        },
    },
    dashboard: {
        title: "Pārskats",
        quickActions: "Ātrās darbības",
        addExpense: "Pievienot izdevumu",
        editCar: "Labot auto",
        recentExpenses: "Izdevumi",
        seeAll: "Skatīt visus",
        recentGallery: "Faili",
        thisMonth: "Šis mēnesis",
        totalSpent: "Kopā iztērēts",
        avgPerMonth: "Vid/Mēn",
        recentNotes: "Piezīmes",
        recentParts: "Rezerves detaļas",
        noRecentExpenses: "Nav pēdējo izdevumu",
        noRecentGallery: "Nav pēdējo foto",
        noRecentNotes: "Nav pēdējo piezīmju",
        noRecentParts: "Nav pēdējo detaļu",
        createNote: "Izveido jaunu",
        createPart: "Izveido jaunu",
        createExpense: "Izveido jaunu",
        noFiles: "Nav vēl neviens fails pievienots",
        needSomethingMore: "Nepieciešams vēl kaut kas?",
        letUsKnow: "dod ziņu!",
    },
    expenseTypes: {
        editTitle: "Labot izdevumu veidu",
        newTitle: "Jauns izdevumu veids",
        categoryName: "Kategorijas nosaukums",
        placeholderName: "piem., Serviss",
        signatureColor: "Raksturīgā krāsa",
        icon: "Kategorijas ikona",
        deleteConfirm: "Vai tiešām vēlaties dzēst veidu '{name}'?",
    },
    spareParts: {
        title: "Rezerves detaļas",
        connectedWithRecords: "Savienots ar ierakstiem",
        toBuy: "Jāpērk",
        usedInExpenses: "Izmantots labošanā",
        noPartsToBuy: "Iepirkumu sarakstā nav detaļu",
        noPartsUsed: "Vēl nav detaļu, kas saistītas ar izdevumiem",
        quantity: "Daudzums",
        partCode: "Kods",
        price: "Cena",
        link: "Saite",
        comment: "Komentārs",
        addPart: "Pievienot detaļu",
        editPart: "Labot rezerves detaļu",
        openPart: "Atvērt detaļu ierakstu",
        nameLabel: "Nosaukums",
        manufacturerLabel: "Ražotājs",
        priceLabel: "Cena ({currency})",
        imagesLabel: "Faili",
        linkedHistory: "Saistītā vēsture",
        partManagedNote: "Šī detaļa tiek pārvaldīta caur izdevumiem",
        cannotDeleteNote: "Tā kā šī detaļa ir piesaistīta izdevumam, to nevar dzēst atsevišķi. Dzēsiet vai labojiet izdevumu, lai pārvaldītu šo detaļu.",
        partNamePlaceholder: "Detaļas nosaukums...",
        manufacturerPlaceholder: "Bosch, Brembo, u.c.",
        additionalInfoPlaceholder: "Papildu informācija",
        namePlaceholder: "piem. Bremžu kluči",
        codePlaceholder: "piem. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Saglabāt",
        deletePart: "Dzēst rezerves detaļu",
        deleteConfirm: "Vai tiešām vēlaties dzēst šo rezerves detaļu?",
        sparePartsLabel: "Rezerves detaļas",
        partNumber: "Detaļa #{number}",
        imagesLimitLabel: "Faili (līdz 5)",
        optional: "",
        selectPart: "Izvēlēties rezerves detaļu",
        createNew: "Izveidot jaunu rezerves detaļu",
        searchPlaceholder: "Meklēt pēc nosaukuma vai koda...",
        noResults: "Detaļas nav atrastas",
        noPartsYet: "Vēl nav detaļu. Izveidojiet pirmo!",
        selectorDescription: "Atrodi un izvēlies esošu rezerves detaļu, vai veido jaunu",
        alreadyAdded: "Šī detaļa jau ir pievienota",
        statistics: {
            avgPrice: "Vid",
            lastPrice: "Pēd",
            usedTimes: "Izmantots {count} reizes",
            totalPurchased: "Kopā: {quantity}x",
        },
        usage: {
            title: "Papildu informācija",
            quantity: "Daudzums",
            pricePerUnit: "Cena par vienību",
            comment: "Komentārs",
            commentPlaceholder: "piem., Nopirkts AutoZone",
            total: "Kopā",
            transactionData: "Šī lietošanas reize",
        },
        masterData: "Detaļas pamatinformācija",
        masterRecord: {
            title: "Detaļas detaļas (kopīgas)",
            editMaster: "Labot galveno ierakstu",
            warning: "Izmaiņas galvenajā ierakstā ietekmē visus lietojumus",
        },
    },
    reminders: {
        title: "Atgādinājumi",
        reminder: "Atgādinājums",
        noteReminder: "Piezīmes atgādinājums",
        partReminder: "Detaļas atgādinājums",
        today: "Šodien",
        tomorrow: "Rītdien",
        yesterday: "Vakar",
        inXDays: "pēc {x} dienām",
        xDaysAgo: "pirms {x} dienām",
        inXMonths: "pēc {x} mēnešiem",
        xMonthsAgo: "pirms {x} mēnešiem",
        active: "Aktīvs",
        activeDesc: "Ja nepieciešams, var izslēgt šo atgādinājumu, nedzēšot",
        disabled: "Izslēgts",
        yearly: "Katru gadu",
        markSeen: "Apstiprināt",
        addReminder: "Pievienot jaunu",
        editReminder: "Labot atgādinājumu",
        extraReminders: "Papildu atgādinājumi",
        extraRemindersDesc: "Nosūtīt vēl 3 atgādinājumus nākamajās dienās (kopā 4), ja netiks izslēgts.",
        remindDate: "Datums",
        remindTime: "Laiks",
        repeatYearly: "Atkārtot katru gadu",
        repeatYearlyDesc: "Šis atgādinājums notiks automātiski katru gadu tajā pašā datumā/mēnesī/dienā/laikā līdz tiks izslēgts",
        standalone: "Atsevišķi atgādinājumi",
        embedded: "Saistītie atgādinājumi",
        noReminders: "Nav aktīvu atgādinājumu",
        deleteReminder: "Dzēst atgādinājumu",
        nameLabel: "Nosaukums",
        descriptionLabel: "Apraksts",
        namePlaceholder: "Atgādinājuma nosaukums",
        descriptionPlaceholder: "Īss apraksts vai piezīme",
        simulateReminder: "Simulēt atgādinājuma brīdi",
        simulateSuccess: "Simulācijas e-pasts nosūtīts",
        timezone: "Laika zona",
        nextReminder: "Nākamais atgādinājums",
        futureTimeError: "Atgādinājuma laikam jābūt nākotnē",
    },
    notes: {
        title: "Piezīmes",
        emptyNote: "Tukša piezīme",
        noNotes: "Vēl nav piezīmju",
        addNote: "Pievienot piezīmi",
        editNote: "Labot piezīmi",
        viewNote: "Skatīt piezīmi",
        openNote: "Atvērt piezīmi",
        titleLabel: "Virsraksts",
        contentLabel: "Saturs",
        noteTitlePlaceholder: "Piezīmes virsraksts...",
        noteContentPlaceholder: "Rakstiet savu piezīmi šeit...",
        saveNote: "Saglabāt",
        deleteNote: "Dzēst piezīmi",
        publicNote: "Šis ieraksts būs publiski redzams",
        publicNoteDesc: "Citi varēs redzēt šo piezīmi caur kopīgotu saiti",
        deleteConfirm: "Vai tiešām vēlaties dzēst šo piezīmi?",
        enterTitleAlert: "Lūdzu, ievadiet virsrakstu",
        saveFailed: "Neizdevās saglabāt piezīmi",
        thisNote: "Šī piezīme",
        deleteFailed: "Neizdevās izdzēst piezīmi",
        pinToTop: "Piesprausts augšpusē",
    },
    locations: {
        title: "Lokācijas",
        singleTitle: "Lokācija",
        newLocation: "Jauna lokācija",
        emptyLocation: "Tukša lokācija",
        noLocations: "Statistikai - vari pievienot lokāciju kur ir notikusi šī auto 'izmaksa'",
        addLocation: "Pievienot lokāciju",
        editLocation: "Labot lokāciju",
        viewLocation: "Skatīt lokāciju",
        openLocation: "Atvērt lokāciju",
        createNew: "Pievienot jaunu",
        selectLocation: "Izvēlēties lokāciju",
        searchLocations: "Meklēt lokācijas...",
        nameLabel: "Nosaukums",
        addressLabel: "Adrese vai Koordinātes",
        descriptionLabel: "Apraksts",
        namePlaceholder: "piemēram, Kurbads Serviss",
        mapLabel: "Atrašanās vieta",
        searchPlaceholder: "Meklēt adresi...",
        addressPlaceholder: "Ievadiet adresi un izvēlieties...",
        descriptionPlaceholder: "Papildu informācija...",
        fillAddress: "Aizpildīt adresi no kartes",
        saveLocation: "Saglabāt",
        deleteLocation: "Dzēst lokāciju",
        deleteConfirm: "Vai tiešām vēlaties dzēst šo lokāciju?",
        enterNameAlert: "Lūdzu, ievadiet nosaukumu",
        saveFailed: "Neizdevās saglabāt lokāciju",
        thisLocation: "Šī lokācija",
        deleteFailed: "Neizdevās izdzēst lokāciju",
        myLocations: "Manas Lokācijas",
        usedInEntries: "Izmantots ierakstos",
        noEntries: "Lokācija netiek izmantota",
        noEntriesThisCar: "Šim auto nav izmantota šī lokācija",
        removeLocation: "Noņemt lokāciju",
        noResults: "Rezultāti nav atrasti",
    },
    gallery: {
        title: "Faili",
        noImages: "Nav pievienotu attēlu",
        addImagesNote: "Pievienojiet attēlus auto vai izdevumiem",
        totalImages: "Kopā {count} attēli",
        imageAlt: "Attēls {number}",
        commentPlaceholder: "Faila komentārs",
        isReceipt: "Šis fails ir čeks",
        deleteImageTitle: "Dzēst failu",
        deleteImageConfirm: "Vai tiešām vēlaties neatgriezeniski dzēst šo failu?",
    },
    search: {
        placeholder: "Meklēt izdevumus, detaļas, piezīmes...",
        typeToSearch: "Sāciet rakstīt, lai meklētu",
        noResults: "Nekas netika atrasts vaicājumam '{query}'",
        carImage: "Auto attēls",
        expenseImage: "Izdevuma attēls",
        noteImage: "Piezīmes attēls",
        galleryImage: "Galerijas attēls",
        untitledExpense: "Nenosaukts izdevums",
    },
    landing: {
        nav: {
            features: "Funkcijas",
            howItWorks: "Kā tas strādā",
            pricing: "Cenas",
            login: "Pieslēgties",
            getStarted: "Sākt tūlīt",
            garage: "Garāža",
        },
        hero: {
            title: "Beidziet minēt. Sāciet zināt savu",
            subtitle: "Auto patieso vērtību.",
            description: "Izturieties pret savu auto kā pret investīciju: pārvērtiet servisa vēsturi par stratēģisku priekšrocību un ziniet precīzu brīdi, kad to paturēt, pārdot vai atjaunināt.",
            subheadline: "Profesionāla datu vadīta informācijas panelis rūpīgiem auto īpašniekiem.",
            startTracking: "Sākt tūlīt",
            viewDemo: "Demo auto ->",
            trustSignal: "Pievienojieties 1,200+ rūpīgiem īpašniekiem, kuri jau ir kartējuši vairāk nekā 5 miljonus kilometru reālo auto izmaksu.",
            ctaNote: "Nav kredītkartes. Nav uzmācīgu pārdošanas piedāvājumu. Tikai skaidrība.",
            benefits: {
                repairVsSell: {
                    title: 'Atrodi "Remontēt vai Pārdot" slieksni',
                    description: 'Beidziet minēt, vai investējat "bezgalīgā caurumā". Ziniet precīzu brīdi, kad remonts vairs nav gudrs ieguldījums.'
                },
                costPerKm: {
                    title: 'Seko savam reālajam CPK (izmaksas uz km)',
                    description: 'Ieraugiet pilnu finanšu bildi un reālās braukšanas izmaksas, ko citas lietotnes palaiž garām.'
                },
                automation: {
                    title: 'Automatizē savu uzskaiti',
                    description: 'Vienkārši pārsūtiet rēķinus vai e-pastus. Mūsu AI sakārtos jūsu auto tehnisko vēsturi jūsu vietā.'
                }
            }
        },
        features: {
            title: "Vairāk nekā tikai uzskaite",
            subtitle: "Jaudīgi rīki, kas palīdz izlemt, kad ir pienācis laiks maiņai.",
            expenseTracking: {
                title: "Izdevumu uzskaite",
                description: "Reģistrē degvielu, servisu, apdrošināšanu un remontus. Kategorizē izmaksas un vizualizē tēriņu tendences.",
            },
            spareParts: {
                title: "Rezerves daļu pārvaldnieks",
                description: "Uzturi detalizētu rezerves daļu, kodu un saderības piezīmju inventāru visiem remontiem.",
            },
            serviceHistory: {
                title: "Servisa vēsture un piezīmes",
                description: "Uzturi digitālu servisa grāmatiņu. Pievieno detalizētas piezīmes par apkopēm, modifikācijām vai nākotnes plāniem.",
            },
            documentStorage: {
                title: "Dokumentu glabātuve",
                description: "Augšupielādē čekus, rēķinus un auto fotoattēlus. Glabā visu dokumentāciju drošībā un pieejamu.",
            },
            emailForwarding: {
                title: "E-pastu pārsūtīšana",
                description: "Pārsūti rēķinus tieši uz savu unikālo e-pastu. Mēs izvilksim datus un automātiski pievienosim tos tavam panelim.",
            },
            multiCar: {
                title: "Vairāku auto garāža",
                description: "Pārvaldi vienu auto vai visu autoparku. Pārslēdzies starp transportlīdzekļiem un skati apkopotu statistiku.",
            },
            repeatingExpenses: {
                title: "Atkārtotie izdevumi",
                description: "Automātiski uzskaiti regulāros mēneša maksājumus, piemēram, apdrošināšanu vai stāvvietu.",
            },
            smartReminders: {
                title: "Viedie atgādinājumi",
                description: "Iestati atgādinājumus rezerves daļām un piezīmēm, lai nekad nepalaistu garām apkopi.",
            },
        },
        howItWorks: {
            title: "Vienkārša un jaudīga plūsma",
            step1: {
                title: "Pievieno savu auto",
                description: "Ievadi auto detaļas, lai izveidotu savu digitālo garāžu.",
            },
            step2: {
                title: "Reģistrē izdevumus un failus",
                description: "Nofotografē čeku vai pārsūti e-pastu. Mēs parūpēsimies par pārējo.",
            },
            step3: {
                title: "Gūsti ieskatu",
                description: "Redzi izmaksas uz {unit}, ikmēneša tēriņus un apkopju laika līniju.",
            },
        },
        useCases: {
            title: "Ideāli piemērots",
            enthusiasts: {
                title: "Auto entuziastiem",
                description: "Seko līdzi katrai modifikācijai, detaļas kodam un apkopes intervālam savam projektam.",
            },
            dailyDrivers: {
                title: "Ikdienas braucējiem",
                description: "Zini precīzi, cik izmaksā tavs brauciens un nekad nepalaid garām apkopi.",
            },
            flippers: {
                title: "Auto pārpircējiem",
                description: "Veidojiet pārliecinošu datu vēsturi, kas pierāda jūsu auto patieso vērtību pircējiem.",
            },
            fleets: {
                title: "Maziem autoparkiem",
                description: "Pārvaldi vairākus uzņēmuma auto vienuviet bez sarežģītas programmatūras.",
            },
        },
        foundersNote: {
            title: "Dibinātāja piezīme",
            content: "Es veidoju MyCarCosts kā ultimālu rīku cilvēkiem, kuriem tiešām rūp viņu auto. Vai jūsu darba plūsmā trūkst kādas funkcijas? Sazinieties ar mani tieši. Ja tam būs jēga kopienai, mēs to uzbūvēsim kopā.",
        },
        pricing: {
            title: "Vienkārša un caurspīdīga cena",
            subtitle: "Sāc bez maksas, audz kopā ar mums.",
            freeLimitedTime: "Bezmaksas uz ierobežotu laiku",
            perMonth: "mēnesī",
            monthly: "Mēneša",
            yearly: "Gada",
            save25: "Ietaupi 25%",
            billedAnnually: "Maksājot par gadu ({amount})",
            free: {
                title: "Bezmaksas",
                cta: "Sākt tūlīt",
            },
            pro: {
                title: "Pro",
                cta: "Pāriet uz Pro",
                recommended: "Ieteiktais",
                earlyAdopter: "Agrīnā cena",
                priceLock: "Nofiksē šo cenu tagad. Nākotnē cena var pieaugt.",
            },
            custom: {
                title: "Individuālais",
                cta: "Sazināties",
            },
            features: {
                oneCar: "1 auto",
                unlimitedExpenses: "Neierobežoti izdevumi",
                unlimitedSpareParts: "Neierobežotas rezerves daļas",
                unlimitedNotes: "Neierobežotas piezīmes",
                repeatedExpenses: "Atkārtotie izdevumi",
                emailReminders: "Piezīmju un rezerves daļu e-pasta atgādinājumi",
                basicStatistics: "Pamata statistika",
                fullStatistics: "Pilna statistika",
                storage50mb: "50 Mb failu krātuve",
                unlimitedArchivedCars: "Neierobežots arhivēto auto skaits",
                dataExport: "Datu eksports",
                allInFreePlus: "viss bezmaksas plānā plus:",
                threeCars: "līdz 3 auto",
                storage2gb: "2 Gb failu krātuve",
                emailParsing: "E-pastu apstrāde",
                carAdmins: "Auto administratori",
                moreCars: "Vairāk auto",
                moreFileStorage: "Lielāka failu krātuve",
                customRequirements: "Pielāgotas prasības",
            },
            upgradePopup: {
                title: "Drīzumā būs pieejams!",
                message: "Pagaidām vēl pro vai custom versija nav palaista, bet drīz būs. Un lai palīdzētu mums ātrāk palaist - ieraksti kuru tieši fīču Tu sagaidi no pro / custom versijas un varbūt ir vēl kautkas ko gribētu, lai mēs varam šo platformu/produktu uztaisīt vēl labāku un parocīgāku!",
                placeholder: "Ieraksti savu svēto vēlmi šeit...",
                submit: "Nosūtīt",
                cancel: "Atcelt",
                thanksTitle: "Paldies!",
                thanksMessage: "Mēs esam saņēmuši Jūsu vēlmes un strādāsim, lai MyCarCosts kļūtu vēl labāks!",
                thanksOk: "Labi",
            },
        },
        migration: {
            title: "Pārej no Excel vai citas lietotnes?",
            subtitle: "Mēs piedāvājam profesionālu datu migrācijas pakalpojumu, lai tu varētu sākt darbu nekavējoties.",
            pricingModel: "Cenu modelis",
            small: {
                title: "Mazs datu apjoms",
                description: "< 500 rindas",
                price: "€19–29",
            },
            medium: {
                title: "Vidējs datu apjoms",
                description: "500–5,000 rindas",
                price: "€49",
            },
            large: {
                title: "Liels / Sarežģīts",
                description: "Vecas sistēmas vai sarežģīti faili",
                price: "Individuāls piedāvājums",
            },
            process: {
                title: "Kā tas notiek",
                step1: "Tu iesūti savu failu",
                step2: "Mēs izvērtējam datus",
                step3: "Vienreizējs maksājums",
                step4: "Mēs veicam importu",
            },
            cta: "Pieprasīt migrāciju",
        },
        repairAnalysisSection: {
            title: "Remonta lēmumu analīze",
            subtitle: "Profesionāls auto veselības un finanšu novērtējums. Izmanto sava auto reālos datus un plānotos izdevumus, lai pieņemtu pareizo lēmumu.",
            features: {
                personalized: {
                    title: "Personalizēta analīze",
                    description: "Viņš ņems ievadītos izdevumus un parametrus, ko vari papildināt ar plānotajiem izdevumiem, un uzģenerēs precīzu auto health novērtējumu.",
                },
                public: {
                    title: "Publiskais simulators",
                    description: "Vēl neesi lietotājs? Izvērtē jebkuru auto sadaļā /repair, ievadot tikai dažus datus, un saņem tikpat detalizētu analīzi.",
                },
                whatIf: {
                    title: "Kas-Ja simulators",
                    description: "Ievadi jebkuru plānoto remonta summu un uzzini, kā tas ietekmē tava auto finanšu vērtējumu.",
                },
            },
            cta: "Remonta lēmumu analīze",
        },
        faq: {
            title: "Biežāk uzdotie jautājumi",
            subtitle: "Viss, kas jāzina par My Car Costs",
            questions: {
                mobileApps: {
                    question: "Vai būs iOS un Android aplikācijas?",
                    answer: "Jā! Mobilās aplikācijas gan iOS, gan Android ierīcēm drīzumā būs pieejamas. Mēs strādājam, lai jums piedāvātu labāko mobilo pieredzi.",
                },
                dataPrivacy: {
                    question: "Vai mani dati ir privāti un droši?",
                    answer: "Protams! Jūsu dati ir šifrēti un droši glabāti. Tikai jūs varat piekļūt savai auto informācijai, ja vien neesat izvēlējies to padarīt publiski pieejamu.",
                },
                freePlan: {
                    question: "Vai bezmaksas plāns tiešām ir bezmaksas uz visiem laikiem?",
                    answer: "Jā! Bezmaksas plāns vienmēr būs pieejams ar vienu auto un visām pamata funkcijām. Jūs varat jebkurā laikā pāriet uz Pro plānu, lai iegūtu līdz 3 auto un papildu funkcijas.",
                },
                dataExport: {
                    question: "Vai varu eksportēt savus datus?",
                    answer: "Jā, jūs varat jebkurā laikā eksportēt visus savus datus CSV vai PDF formātā. Jūsu dati pieder jums, un jūs nekad neesat ieslēgts sistēmā.",
                },
                emailImport: {
                    question: "Kā darbojas e-pasta imports?",
                    answer: "Katrs auto saņem unikālu e-pasta adresi. Vienkārši pārsūtiet savus rēķinus uz šo adresi, un mēs automātiski izvilksim datus.",
                },
                multipleUsers: {
                    question: "Vai vairāki cilvēki var piekļūt vienam auto?",
                    answer: "Pašlaik katrs auto pieder vienam kontam. Tomēr jūs varat padarīt auto publiski redzamu, lai dalītos ar citiem tikai lasīšanas piekļuvē.",
                },
            },
        },
        cta: {
            title: "Beidz minēt. Sāc zināt.",
            subtitle: "Pārvērt sava auto vēsturi skaidros lēmumos. Pievienojies tūkstošiem gudru saimnieku, kuri precīzi zina, kad ieguldīt un kad pārdot.",
            button: "Sākt tūlīt",
            note: "Nav kredītkartes. Nav uzbāzīgas pārdošanas. Tikai skaidrība.",
        },
        footer: {
            product: "Produkts",
            legal: "Juridiskā informācija",
            changelog: "Izmaiņu žurnāls",
            privacy: "Privātuma politika",
            contact: "Kontakti",
            contactEmail: "info@mycarcosts.com",
            questions: "Kādi jautājumi? Sazinieties ar mums:",
        },
        privacy: {
            title: "Privātuma politika",
            lastUpdated: "Atjaunots: 2026. gada 24. martā",
            introduction: "My Car Costs mēs nopietni izturamies pret jūsu privātumu. Šī politika izskaidro, kā mēs apstrādājam jūsu datus saskaņā ar mūsdienu privātuma standartiem, ieskaitot GDPR.",
            dataCollection: {
                title: "Datu vākšana",
                description: "Mēs vācam tikai pašu nepieciešamāko informāciju, kas nepieciešama mūsu pakalpojuma nodrošināšanai.",
                email: "Konta identitāte: Mēs izmantojam jūsu e-pasta adresi kā unikālo identifikatoru un autentifikācijai (piemēram, maģiskās saites vai Google pieteikšanās).",
                documents: "Dokumentu glabāšana: Jūsu augšupielādētie faili tiek droši glabāti šifrētā mākoņkrātuvē.",
            },
            carData: {
                title: "Jūsu datu kontrole",
                description: "Informācija, ko ievadāt (izdevumi, nobraukums, detaļas), tiek glabāta jūsu personīgai lietošanai un analītikai.",
                noValidation: "Mēs nevalidējam jūsu sniegtos auto datus; jūs esat atbildīgs par to precizitāti.",
                privateByDefault: "Pēc noklusējuma jūsu dati ir privāti. Failu tehniskie identifikatori ir nesecīgi un meklētājprogrammas tos neindeksē.",
                rightToForgotten: "Tiesības tikt aizmirstam: Jūs varat izdzēst savu kontu jebkurā laikā, kas nekavējoties un neatgriezeniski dzēš visus jūsu ierakstus un failus.",
            },
            thirdParty: {
                title: "Trešo pušu pakalpojumi",
                description: "Mēs nepārdodam jūsu personas datus. Izmantojot Google pieteikšanos, mēs piekļūstam tikai jūsu e-pasta adresei identifikācijas nolūkos.",
            },
            emailIngestion: {
                title: "E-pasts uz ierakstu",
                description: "E-pasti, kas nosūtīti mūsu apstrādes dienestam, tiek glabāti, lai nodrošinātu apstrādes vēsturi. Jūs varat manuāli dzēst atsevišķus e-pastus vai visu vēsturi jebkurā laikā.",
            },
        },
        emails: {
            deleteAll: "Dzēst visus",
            deleteAllConfirm: "Vai tiešām vēlaties dzēst visu šī auto e-pastu vēsturi? Šī darbība ir neatgriezeniska.",
            deleteConfirm: "Vai tiešām vēlaties dzēst šo e-pastu?",
            noEmails: "Vēl nav saņemts neviens e-pasts.",
        },
        terms: {
            title: "Lietošanas noteikumi",
            lastUpdated: "Pēdējo reizi atjaunināts: 2026. gada 25. martā",
            introduction: "Piekļūstot vai izmantojot MyCarCosts, jūs piekrītat šiem Lietošanas noteikumiem. Ja nepiekrītat, lūdzu, neizmantojiet mūsu pakalpojumu.",
            acceptance: {
                title: "1. Noteikumu pieņemšana",
                description: "Šie noteikumi veido juridiski saistošu līgumu starp jums un MyCarCosts attiecībā uz mūsu lietotnes un pakalpojumu izmantošanu.",
            },
            service: {
                title: "2. Pakalpojuma apraksts",
                description: "MyCarCosts nodrošina platformu transportlīdzekļu izdevumu uzskaitei, apkopes pārvaldībai un finanšu analīzei. Tas ietver AI rēķinu apstrādi un datu vizualizācijas rīkus.",
            },
            responsibilities: {
                title: "3. Lietotāja atbildība",
                description: "Jūs esat atbildīgs par ievadīto datu precizitāti, tostarp nobraukumu, VIN numuriem un izmaksām. Jums ir droši jāglabā savi pieslēgšanās dati un tie jānodod trešajām personām.",
            },
            plans: {
                title: "4. Pakalpojumu plāni un limiti",
                description: "Mēs piedāvājam Bezmaksas un Pro plānus ar atšķirīgiem atmiņas, auto skaita un augšupielādes limitiem. Mēs paturam tiesības jebkurā laikā mainīt šos limitus vai ieviest jaunas abonēšanas pakāpes.",
            },
            disclaimer: {
                title: "5. Atruna un precizitāte",
                description: "MyCarCosts ir informatīvs un organizatorisks rīks. Mēs nesniedzam oficiālus transportlīdzekļa stāvokļa sertifikātus. AI apstrādātie dati no rēķiniem lietotājam vienmēr ir jāpārbauda.",
            },
            liability: {
                title: "6. Atbildības ierobežošana",
                description: "MyCarCosts pakalpojums tiek sniegts 'tāds, kāds tas ir'. Mēs neuzņemamies atbildību par tehniskām problēmām, finansiāliem zaudējumiem vai datu neprecizitātēm, kas radušies lietotnes izmantošanas rezultātā.",
            },
            termination: {
                title: "7. Izbeigšana",
                description: "Jūs varat pārtraukt pakalpojuma izmantošanu un izdzēst savus datus jebkurā laikā. Mēs paturam tiesības apturēt vai dzēst kontus, kas pārkāpj šos noteikumus vai ļaunprātīgi izmanto sistēmu.",
            },
        },
    },
    audit: {
        hero: {
            badge: 'Jauns: Aizsardzības rīks',
            title: 'Konsultējies ar Orakulu.',
            subtitle: 'Beidz minēt, vai mehāniķis Tevi māna. Ielīmē tāmi, apraksti troksni vai pievieno foto. Saņem tiešu un loģikā balstītu "labot vai pārdot" verdiktu 60 sekundēs.',
            cta: 'Konsultēties ar Orakulu',
            smallPrint: '100% privāti. Nav nepieciešama karte.',
            walletSecurity: 'AI jauda Jūsu maciņa drošībai'
        },
        demo: {
            title: 'Audita rezultāti',
            verdictSell: 'Verdikts: PĀRDOT',
            repairVsValue: 'Remonts pret vērtību',
            cashGapSavings: 'Aizvietošanas starpība',
            savingsValue: 'Ietaupījums: $3,200',
            roiStrategyTitle: 'ROI Stratēģija',
            roiStrategyText: 'Ieguldīt $2,100 nolietotā $4,500 aktīvā ir negatīvs ROI. Aizvietošana ar 2018. gada modeli ietaupīs Tev $3,200 ilgtermiņā.',
            benefitsTitle: 'Beidz minēt. Pārvaldi sava auto ROI.',
            ctaSubtext: 'Beidz minēt. Ieraugi sava auto izmaksas caur loģikas prizmu.'
        },
        form: {
            uploadTitle: 'Fotoattēli vai dokumenti (neobligāti)',
            uploadDesc: 'Augšupielādē tāmes foto vai problēmvietas attēlu.',
            emailLabel: 'E-pasta adrese',
            emailPlaceholder: 'Kur nosūtīt atskaiti?',
            carLabel: 'Auto modelis',
            carPlaceholder: 'piem. 2018 BMW X5 TDI 2.0 sedans',
            descLabel: 'Aprakstiet situāciju vai problēmu',
            descPlaceholder: 'Ielīmē mehāniķa tāmi, apraksti troksni vai pastāsti par problēmu...',
            submit: 'Konsultēties ar Orakulu',
            submitting: 'Apstrādā...',
            successTitle: 'Tāme saņemta!',
            successDesc: 'Mūsu AI aģenti analizē datus. Detalizētu ziņojumu saņemsiet e-pastā {email} 60 sekunžu laikā.',
            errorNoFiles: 'Lūdzu, norādiet aprakstu vai augšupielādējiet failu.',
            errorNoEmail: 'Lūdzu, ievadiet savu e-pasta adresi.',
            verifiedBy: 'Verificēts ar Double-Agent protokolu'
        },
        progress: {
            analyzing: 'Analīze procesā...',
            scanning: 'Dokumentu skenēšana',
            checking: 'Tirgus datu pārbaude',
            roi: 'ROI aprēķini',
            finalizing: 'Gatava atskaite',
            lightningTitle: 'Pirmais iespaids',
            lightningBadge: 'ZIBENS-ANALĪZE',
            firstImpression: 'Pirmais iespaids',
            checkEmail: 'Pārbaudiet savu e-pastu pēc 60 sekundēm',
            anotherAudit: 'Auditēt citu situāciju',
            statusDesc: 'Mūsu "Double-Agent" sistēma šobrīd pārbauda Jūsu datus. Galīgais ziņojums tiks nosūtīts uz e-pastu.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analīze',
                desc: 'Nepārmaksājiet par darbu. Iegūstiet uz datiem balstītus argumentus par reāliem remonta laikiem.'
            },
            peace: {
                title: 'Lēmums 60 sekundēs',
                desc: 'Uzziniet droši, vai tavs mehāniķis ir godīgs par nepieciešamajiem remontiem vai mēģina "uzpūst" rēķinu.'
            },
            scams: {
                title: 'Izvairies no liekām izmaksām',
                desc: 'Mūsu datubāze rāda, ka pilsētu dīleru tāmes bieži tiek "uzpūstas" par ~22% ar liekām "konsultāciju" vai "pārbaudes" maksām.'
            },
            technical: {
                title: 'Aizvietošanas loģika',
                desc: 'Mēs aprēķinām "Cash Gap" — cik Jums reāli maksātu šī auto remonts pret līdzvērtīga, uzticama auto iegādi.'
            }
        },
            cta: {
            title: 'Pārtrauc tērēt naudu auto, kas nav tā vērts.',
            button: 'Auditēt situāciju tagad'
        },
        howItWorks: {
            title: 'Kā tas strādā',
            subtitle: '"Double-Agent" sistēma nodrošina faktus, nevis tukšas runas.',
            extract: {
                title: 'Datu nolasīšana',
                desc: 'Mēs analizējam Tavu situāciju un auto modeli, ņemot vērā nobraukumu un tipiskos servisa ciklus.'
            },
            analyze: {
                title: 'Tirgus analīze',
                desc: 'AI salīdzina remonta izmaksas ar pašreizējo tirgus vērtību un uzticamības reitingiem.'
            },
            audit: {
                title: 'ROI kalkulācija',
                desc: 'Mēs aprēķinām finanšu starpību starp remonta veikšanu un auto pārdošanu šajā brīdī.'
            },
            verdict: {
                title: 'Verdikts',
                desc: 'Tu saņem skaidru "Repair vs Sell" atskaiti ar pamatojumu un rīcības prioritātēm.'
            }
        },
        results: {
            priceRealityCheck: 'Cenu realitātes pārbaude',
            roadmapTitle: 'Kas salūzīs nākamais?',
            roadmapBadge: 'Nākotnes prognoze',
            unlockFullReport: 'Atbloķēt pilno atskaiti',
            realWorldInsights: 'Ieskats reālos piemēros',
            oracleAdvice: 'Orakula padomi no dzīves',
            oracleAdviceSub: 'Uzzini kā mūsu AI palīdz cilvēkiem risināt sarežģītas auto problēmas.',
            readFullAudit: 'Lasīt pilno auditu',
            potentialSaving: 'Iespējamais ietaupījums',
            getYourOwn: 'Saņem savu Orakula auditu',
            savingsPotentialFound: 'Atrasta iespēja ietaupīt',
            negotiationScript: 'Sarunu skripts'
        },
        caseStudy: {
            backToAudit: 'Atpakaļ uz auditu',
            oracleCaseStudy: 'Orakula piemērs',
            realUserQuestion: 'Reāls lietotāja jautājums',
            officialAudit: 'Oficiāls Orakula audits',
            fullReport: 'Pilns lēmuma ziņojums',
            economicImpact: 'Ekonomiskā ietekme',
            startYourAudit: 'Sākt savu auditu',
            moreAudits: 'Vairāk reālu piemēru',
            sharingIsCaring: 'Dalies ar citiem. Saudzē draugu maciņus.',
            poweredBy: 'Nodrošina MyCarCosts Double-Agent mākslīgais intelekts'
        }
    },
    jarvis: {
        title: 'Džarviss',
        subtitle: 'AI Garāžas Agents',
        askJarvis: 'Jautāt Džarvisam...',
        typing: 'Džarviss domā...',
        safetyWarning: 'Drošības Brīdinājums',
        repairVerdict: 'Remonta Verdikts',
        diyFeasibility: 'DIY Sarežģītība'
    },
    repairMode: {
        oracleStatus: 'Oracle Statuss: {status}',
        verdictKeep: 'PATURĒT',
        verdictSell: 'PĀRDOT',
        verdictBorderline: 'ROBEŽGADĪJUMS'
    }
};
